import {
  Avatar,
  Box,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { FaCheckCircle, FaTimes } from "react-icons/fa";
import arrowLeftBroken from "../../assests/images/arrowLeftBroken.png";

const RightSide = (props) => {
  const { selectedPicks, handleRemovePick } = props;

  return (
    <>
      {/* Right Side - Pick Summary */}
      {/* <Grid item xs={12} md={5}>
          <Stack spacing={2}>
           
            <Box
              bgcolor="#f5f5f5"
              borderRadius="20px"
              p={2}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Chip
                label="+ 5% Boost 🚀"
                sx={{
                  backgroundColor: "#222",
                  color: "#fff",
                  borderRadius: "999px",
                }}
              />
              <Typography fontWeight="bold" fontSize={18}>
                2.00x
              </Typography>
            </Box>

            
            {selectedPicks.map((pick, index) => (
              <Paper
                key={index}
                sx={{
                  backgroundColor: "#FFD500",
                  borderRadius: "20px",
                  p: 2,
                  position: "relative",
                }}
              >
                <Typography fontSize={12} mb={1}>
                  *1 entry up to $250
                </Typography>
                <Chip
                  label={
                    <Typography fontWeight="bold" fontSize={12}>
                      Payout Boost Special* &nbsp; 09:04:28
                    </Typography>
                  }
                  sx={{
                    backgroundColor: "#222",
                    color: "#fff",
                    px: 2,
                    py: 0.5,
                    borderRadius: "999px",
                  }}
                />
                <IconButton
                  size="small"
                  sx={{
                    position: "absolute",
                    top: 12,
                    right: 12,
                    color: "gray",
                  }}
                  onClick={() => handleRemovePick(pick.player.id)}
                >
                  <FaTimes />
                </IconButton>

                <Box display="flex" alignItems="center" mt={2} gap={2}>
                  <Avatar
                    src={pick.player.avatar}
                    sx={{ width: 56, height: 56 }}
                  />
                  <Box>
                    <Typography fontWeight="bold">
                      {pick.player.team.split(" - ")[1]} - {pick.player.name}
                    </Typography>
                    <Typography fontSize={12} color="text.secondary">
                      {pick.player.match}
                    </Typography>
                  </Box>
                </Box>

                <Box display="flex" justifyContent="space-between" mt={2}>
                  <Box
                    bgcolor="#fff"
                    borderRadius="16px"
                    p={1}
                    textAlign="center"
                    flex={1}
                    mr={1}
                    fontWeight="bold"
                  >
                    <FaCheckCircle color="#00cc66" /> <br />
                    {pick.option.value} <br />
                    {pick.option.side} <br />
                    {pick.option.label}
                  </Box>
                  <Box
                    bgcolor="#fff"
                    borderRadius="16px"
                    p={1}
                    textAlign="center"
                    flex={1}
                    ml={1}
                  >
                  
                    {pick.option.value} <br />
                    {pick.option.side} <br />
                    {pick.option.label}
                  </Box>
                </Box>
              </Paper>
            ))}

           
            <Box textAlign="center" mt={3}>
              <Typography variant="h5" fontWeight="bold">
                Entry Amount
              </Typography>
              <Typography mt={1} fontSize={14}>
                (min: $1, max: $2500)
              </Typography>
            </Box>
          </Stack>
        </Grid> */}
      {/* Right Side - Pick Summary */}
      <Grid item xs={12} md={5}>
        <Stack spacing={2}>
          {/* Boost Bar */}
          {selectedPicks.length === 0 && (
            <Box
              bgcolor="#FFD500"
              borderRadius="24px"
              p={4}
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              minHeight="400px"
              textAlign="center"
              position="relative"
            >
              {/* Arrow Image */}
              <Box
                component="img"
                src={arrowLeftBroken} // add your arrow image here
                alt="arrow"
                sx={{
                  position: "absolute",
                  left: "-10px", // adjust positioning
                  top: "40%",
                  transform: "translateY(-50%)",
                  width: "80px",
                  height: "auto",
                }}
              />

              {/* Main Text */}
              <Typography fontSize={24} fontWeight="bold" mb={2}>
                Let's Start!
              </Typography>

              {/* Instruction Text */}
              <Typography fontSize={16}>
                Pick at least{" "}
                <Box component="span" fontWeight="bold">
                  two players
                </Box>{" "}
                from{" "}
                <Box component="span" fontWeight="bold">
                  different teams
                </Box>{" "}
                to play
              </Typography>
            </Box>
          )}
          {/* <Box
            bgcolor="#FFD500"
            borderRadius="16px"
            p={2}
            display="flex"
            flexDirection="column"
            alignItems="center"
          >
            <Typography fontSize={14} fontWeight="bold" mb={1}>
              Let's Start!
            </Typography>
         
            <Box alignItems="center" gap={1}>
              <Typography
                sx={{
                  color: "rgba(0,0,0,0.6)",
                  fontWeight: "bold",
                }}
              >
                Pick at least two players
              </Typography>
              <Typography
                sx={{
                  color: "rgba(0,0,0,0.6)",
                  fontWeight: "bold",
                }}
              >
                from different teams to play
              </Typography>
            </Box>
          </Box> */}

          {selectedPicks.length > 0 && (
            <Box
              bgcolor="#FFD500"
              borderRadius="16px"
              p={2}
              display="flex"
              flexDirection="column"
              alignItems="center"
            >
              <Typography fontSize={14} fontWeight="bold" mb={1}>
                Max Boost 🚀
              </Typography>
              {/* Simulated slider */}
              <Box display="flex" alignItems="center" gap={1}>
                <Typography
                  sx={{
                    textDecoration: "line-through",
                    color: "rgba(0,0,0,0.6)",
                    fontWeight: "bold",
                  }}
                >
                  173.1x
                </Typography>
                <Typography fontWeight="bold" fontSize={18}>
                  233.68x
                </Typography>
                <Typography fontSize={12}>(9 picks max)</Typography>
              </Box>
            </Box>
          )}

          {/* Selected Picks */}
          {selectedPicks.map((pick, index) => (
            <Paper
              key={index}
              sx={{
                backgroundColor: "#FFD500",
                borderRadius: "24px",
                p: 2,
                position: "relative",
                overflow: "hidden",
              }}
            >
              <Typography fontSize={12} mb={1}>
                *1 entry up to $250
              </Typography>
              <Box
                bgcolor="#222"
                color="#fff"
                px={2}
                py={0.5}
                borderRadius="999px"
                display="inline-block"
                fontSize={12}
                fontWeight="bold"
              >
                Payout Boost Special* &nbsp; 09:05:17
              </Box>

              {/* Close Icon */}
              <IconButton
                size="small"
                sx={{
                  position: "absolute",
                  top: 12,
                  right: 12,
                  color: "gray",
                }}
                onClick={() => handleRemovePick(pick.player.id)}
              >
                <FaTimes />
              </IconButton>

              {/* Player Info */}
              <Box
                bgcolor="#fff"
                borderRadius="16px"
                mt={2}
                p={2}
                display="flex"
                flexDirection="column"
                alignItems="center"
              >
                <Typography
                  fontWeight="bold"
                  mb={0.5}
                  textAlign="center"
                  fontSize={14}
                >
                  {pick.player.team.split(" - ")[1]} - {pick.player.name}
                </Typography>
                <Typography fontSize={12} color="text.secondary" mb={1}>
                  {pick.player.match}
                </Typography>
                <Avatar
                  src={pick.player.avatar}
                  sx={{ width: 72, height: 72, mb: 1 }}
                />
              </Box>

              {/* Side selections */}
              <Box
                mt={2}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                gap={2}
              >
                {/* Left (Less) */}
                <Box
                  bgcolor="#fff"
                  borderRadius="16px"
                  p={1.5}
                  flex={1}
                  textAlign="center"
                  boxShadow={
                    pick.option.side === "Less"
                      ? "0 0 0 3px #00cc66"
                      : "0 0 4px rgba(0,0,0,0.1)"
                  }
                >
                  {pick.option.side === "Less" && (
                    <FaCheckCircle
                      color="#00cc66"
                      style={{ marginBottom: 4 }}
                    />
                  )}
                  <Typography fontWeight="bold">{pick.option.value}</Typography>
                  <Typography fontWeight="bold">{pick.option.side}</Typography>
                  <Typography fontSize={13}>{pick.option.label}</Typography>
                </Box>

                {/* Right (More) */}
                <Box
                  bgcolor="#fff"
                  borderRadius="16px"
                  p={1.5}
                  flex={1}
                  textAlign="center"
                  boxShadow={
                    pick.option.side === "More"
                      ? "0 0 0 3px #00cc66"
                      : "0 0 4px rgba(0,0,0,0.1)"
                  }
                >
                  {pick.option.side === "More" && (
                    <FaCheckCircle
                      color="#00cc66"
                      style={{ marginBottom: 4 }}
                    />
                  )}
                  <Typography fontWeight="bold">{pick.option.value}</Typography>
                  <Typography fontWeight="bold">{pick.option.side}</Typography>
                  <Typography fontSize={13}>{pick.option.label}</Typography>
                </Box>
              </Box>
            </Paper>
          ))}

          {/* Entry Amount */}
          {selectedPicks.length > 0 && (
            <Box textAlign="center" mt={3}>
              <Typography variant="h5" fontWeight="bold">
                Entry Amount
              </Typography>
              <Typography mt={1} fontSize={14}>
                (min: $1, max: $2500)
              </Typography>
            </Box>
          )}
        </Stack>
      </Grid>
    </>
  );
};

export default RightSide;

// import {
//   Avatar,
//   Box,
//   Button,
//   Grid,
//   IconButton,
//   Paper,
//   Stack,
//   Typography,
// } from "@mui/material";
// import { FaCheckCircle, FaTimes } from "react-icons/fa";

// const RightSide = ({ selectedPicks, handleRemovePick }) => {
//   return (
//     <Grid item xs={12} md={5}>
//       <Stack spacing={2}>

//         {/* Boost Bar */}
//         <Box
//           bgcolor="#ffd700"
//           borderRadius="16px"
//           p={2}
//           display="flex"
//           flexDirection="column"
//           alignItems="center"
//         >
//           <Typography fontSize={14} fontWeight="bold" mb={1}>
//             BOOST 🚀
//           </Typography>
//           <Box display="flex" alignItems="center" gap={1}>
//             <Typography
//               sx={{
//                 textDecoration: "line-through",
//                 color: "rgba(0,0,0,0.6)",
//                 fontWeight: "bold",
//               }}
//             >
//               173.1x
//             </Typography>
//             <Typography fontWeight="bold" fontSize={18}>
//               233.68x
//             </Typography>
//             <Typography fontSize={12}>(9 picks max)</Typography>
//           </Box>
//         </Box>

//         {/* Player Cards */}
//         {selectedPicks.map((pick, index) => (
//           <Paper
//             key={index}
//             sx={{
//               backgroundColor: "#ffffff",
//               border: "2px solid #ffd700",
//               borderRadius: "16px",
//               p: 2,
//               position: "relative",
//             }}
//           >
//             {/* Close icon */}
//             <IconButton
//               size="small"
//               sx={{
//                 position: "absolute",
//                 top: 8,
//                 right: 8,
//                 color: "gray",
//               }}
//               onClick={() => handleRemovePick(pick.player.id)}
//             >
//               <FaTimes />
//             </IconButton>

//             {/* Player Info */}
//             <Box display="flex" alignItems="center" gap={2} mb={2}>
//               <Avatar
//                 src={pick.player.avatar}
//                 sx={{ width: 48, height: 48 }}
//               />
//               <Box>
//                 <Typography fontWeight="bold">
//                   {pick.player.team.split(" - ")[1]} - {pick.player.name}
//                 </Typography>
//                 <Typography fontSize={12} color="text.secondary">
//                   {pick.player.match}
//                 </Typography>
//               </Box>
//             </Box>

//             {/* Less / More Selector */}
//             <Box display="flex" gap={2}>
//               <Box
//                 flex={1}
//                 p={1.5}
//                 borderRadius="12px"
//                 textAlign="center"
//                 bgcolor={pick.option.side === "Less" ? "#e0f7ea" : "#f9f9f9"}
//                 border={
//                   pick.option.side === "Less"
//                     ? "2px solid #00cc66"
//                     : "1px solid #ddd"
//                 }
//               >
//                 {pick.option.side === "Less" && (
//                   <FaCheckCircle color="#00cc66" style={{ marginBottom: 4 }} />
//                 )}
//                 <Typography fontWeight="bold">
//                   {pick.option.value}
//                 </Typography>
//                 <Typography fontWeight="bold">{pick.option.side}</Typography>
//                 <Typography fontSize={13}>{pick.option.label}</Typography>
//               </Box>

//               <Box
//                 flex={1}
//                 p={1.5}
//                 borderRadius="12px"
//                 textAlign="center"
//                 bgcolor={pick.option.side === "More" ? "#e0f7ea" : "#f9f9f9"}
//                 border={
//                   pick.option.side === "More"
//                     ? "2px solid #00cc66"
//                     : "1px solid #ddd"
//                 }
//               >
//                 {pick.option.side === "More" && (
//                   <FaCheckCircle color="#00cc66" style={{ marginBottom: 4 }} />
//                 )}
//                 <Typography fontWeight="bold">
//                   {pick.option.value}
//                 </Typography>
//                 <Typography fontWeight="bold">{pick.option.side}</Typography>
//                 <Typography fontSize={13}>{pick.option.label}</Typography>
//               </Box>
//             </Box>
//           </Paper>
//         ))}

//         {/* Entry Amount */}
//         <Box
//           textAlign="center"
//           mt={2}
//           p={2}
//           borderRadius="16px"
//           bgcolor="#f5f5f5"
//         >
//           <Typography variant="h6" fontWeight="bold">
//             Entry Amount
//           </Typography>
//           <Typography mt={1} fontSize={14}>
//             (min: $1, max: $2500)
//           </Typography>
//           <Button
//             variant="contained"
//             color="primary"
//             size="large"
//             sx={{ mt: 2, borderRadius: "999px", px: 5 }}
//           >
//             Place Entry
//           </Button>
//         </Box>

//       </Stack>
//     </Grid>
//   );
// };

// export default RightSide;
